{
    "WHATSAPP_TEMPLATES": {
        "MODAL": {
            "TITLE": "Plantillas de Whatsapp",
            "SUBTITLE": "Seleccione la plantilla de Whatsapp que desea enviar",
            "TEMPLATE_SELECTED_SUBTITLE": "Procesar {templateName}"
        },
        "PICKER": {
            "SEARCH_PLACEHOLDER": "Buscar plantillas",
            "NO_TEMPLATES_FOUND": "No se encontraron plantillas para",
            "LABELS": {
                "LANGUAGE": "Idioma",
                "TEMPLATE_BODY": "Cuerpo de plantilla",
                "CATEGORY": "Categoría"
            }
        },
        "PARSER": {
            "VARIABLES_LABEL": "Variables",
            "VARIABLE_PLACEHOLDER": "Introduzca el valor de {variable}",
            "GO_BACK_LABEL": "Volver",
            "SEND_MESSAGE_LABEL": "Enviar mensaje",
            "FORM_ERROR_MESSAGE": "Por favor, rellene todas las variables antes de enviar"
        }
    }
}
